export default __webpack_public_path__ + "locales/lo-LA/SMTPSettings.json?hash=69aad8c86fee85ee5b4a3fab4e79e7ae";